import styled, { css } from "styled-components";
import Container from "../components/atoms/Container/Container.styled";
import { withDisplayHeading, withSectionSpacing } from "../themes/mixins";
import { deviceMax } from "../utils/device";

export const TermsSection = styled.section(
  ({ theme }) => css`
    ${withSectionSpacing()};
    background: ${theme.colors.white};
  `
);

export const TermsWrapper = styled(Container)`
  margin: 0 auto;
  max-width: 760px;
`;

export const TermsTitle = styled.h1(
  ({ theme }) => css`
    ${withDisplayHeading("clamp(30px, 4vw, 40px)")};
    color: ${theme.colors.brand.ink};
    margin-bottom: 36px;
  `
);

export const TermsContent = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.brand.ink};
    font-family: ${theme.typography.fonts.body};
    font-size: 15px;
    line-height: 1.75;

    p {
      margin: 0 0 24px;
    }

    h3,
    h4,
    h5 {
      font-family: ${theme.typography.fonts.display};
      color: ${theme.colors.brand.navy};
      font-weight: ${theme.typography.weights.bold};
      line-height: 1.3;
      margin: 0 0 12px;
    }

    h3 {
      color: ${theme.colors.brand.muted};
      font-size: 12px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }

    h4,
    h5 {
      font-size: 17px;
    }

    ul {
      margin: 0 0 16px;
      padding-left: 20px;
    }

    li {
      margin-bottom: 8px;
    }

    a {
      color: ${theme.colors.brand.action};
      text-decoration: underline;
      text-underline-offset: 2px;

      &:hover {
        color: ${theme.colors.brand.deep};
      }
    }

    @media ${deviceMax.phoneMax} {
      font-size: 14px;
    }
  `
);
